import React, { FC } from 'react';
import IFeaturesList from '../../../../../model/IFeaturesList';
import FeatureAccessoryList from '../../features/featureAccessory/featureAccessoryList/FeatureAccessoryList';
import ICategoryAttributes from '../../../../../model/ICategoryAttributes';
import { FeatureAccessoryOrientation } from '../../features/featureAccessory/FeatureAccessory';
import IFeature from '../../../../../model/IFeature';

export interface IDisplayLayoutFiveProps {
  featuresList: IFeaturesList;
  categoryAttributes?: ICategoryAttributes;
  openAccessoryDetailsModal: (value: boolean, feature: IFeature) => void;
}

const LayoutFive: FC<IDisplayLayoutFiveProps> = ({ featuresList, categoryAttributes, openAccessoryDetailsModal }) => {
  return (
    <FeatureAccessoryList
      featuresList={featuresList}
      categoryAttributes={categoryAttributes}
      layoutOrientation={FeatureAccessoryOrientation.LANDSCAPE}
      openAccessoryDetailsModal={openAccessoryDetailsModal}
    />
  );
};

export default LayoutFive;
